<template>
  <div class='rf-page-setup'>
    <div v-show="pagina === 'progresso'" class="app-setup-progress">
      <div>
        <!-- SETA A LOGO -->
        <div class="app-setup-progress-logo">
          <img src="/img/rotina_facil.png" alt="Rotina Fácil">
        </div>

        <div>
          <h2>Seja Bem Vindo(a) ao Rotina Fácil!</h2>
          <h4 style="margin-top: 20px">
            Estamos finalizando seu cadastro.
          </h4>
        </div>

        <!-- SETA A BARRA DE PROGRESSO -->
        <div>
          <div class="app-setup-progress-valor">{{ progress }} % </div>
          <b-progress class="app-setup-progress-barra" :height="'25px'" :value="progress" :max="100" :animated="true"></b-progress>
        </div>

        <div>
          <h4 style="margin-top: 30px;">
            <template v-if="progress < 100">
              Por favor aguarde só mais alguns instantes...
            </template>
            <template v-else>
              Enviando e-mail de boas vindas...
            </template>
          </h4>
        </div>
      </div>
    </div>
      <!-- <b-progress v-if="pagina !== null && pagina >= 1" height="5px" :value="progress" class="mb-2" style="border-radius: 0px;"></b-progress> -->

    <transition name="bounce">
      <div class='rf-page-setup-conteudo' v-show="pagina !== 'progresso'" v-if="pagina !== null" :class="(pagina !== null && pagina >= 1) ? '' : 'page-cadastro'">
        <div class="rf-page-setup-logo" v-if="pagina === 0 && Object.keys(formulario).length >= 1">
          <img src="/img/rotina_facil.png" alt="Rotina Fácil">
        </div>

        <template v-if="pagina === 0 && Object.keys(formulario).length >= 1">
          <div class="rf-page-setup-titulo">
            Vamos começar?
          </div>

          <RF-Formulario v-if="Object.keys(formulario).length >= 1" :data-time='time' class="rf-page-setup-cadastro"
            :cpntTime='time'
            :cpntId='formulario.id' 
            :cpntStatus='formulario.status'
            :cpntField='formulario.field'
            :cpntUltAlt='formulario.ult_alt'
            :cpntTabIndexFieldGeral='formulario.tabIndexFieldGeral'
            :cpntTabIndexButtonGeral='formulario.tabIndexButtonGeral'

            :ref='formulario.id'
          ></RF-Formulario>

          <div v-if="formulario.hasOwnProperty('status') && formulario.status === ''">
            <div class="rf-checkbox" style="width: 330px; margin: 0px auto;">
              <input type="checkbox" :id='"rf-setup-checkbox-termo"' v-model='checkbox'>
              <label :for='"rf-setup-checkbox-termo"' :tabIndex='formulario.tabIndexFieldGeral + 1'></label>
              <span style="cursor: pointer; font-size: var(--font-base-soma-14);" @click="checkbox = !checkbox">
                Declaro que li e concordo com os termos de uso.
              </span>
              <br/>
            </div>
            <div style="cursor: pointer; font-size: var(--font-base-soma-14); color: #337ab7; text-decoration: none; text-align: center;" @click="termoMostrar = !termoMostrar">Ler termos de uso.</div>
          </div>

          <div style="text-align: center; margin: 0px auto; padding: 30px 0px 30px 0px; width: 180px;">
            <RF-Button v-if="formulario.buttons.hasOwnProperty('env') && formulario.buttons.env.hasOwnProperty('disabled')"
              style="width: 180px;"
              :data-time='time'

              :cpntStatus='formulario.buttons.env.status' 
              :cpntId='formulario.buttons.env.id' 
              :cpntTexto='formulario.buttons.env.texto' 
              :cpntClass='formulario.buttons.env.class'
              :cpntMostrar='formulario.buttons.env.mostrar'
              :cpntDisabled='formulario.buttons.env.disabled'
              :cpntTabIndex='formulario.buttons.env.tabIndex'

              @onClickButton='formulario.buttons.env.onClick()'
            ></RF-Button>
          </div>

          <div style="text-align: center; padding: 15px 0px 30px 0px;">
            <router-link :to="{ name: 'con_exi', params: {} }" tag="a">Já sou cliente e gostaria de entrar!</router-link>
          </div>
        </template>

        <div class="rf-setup-perguntas" v-else-if="pagina >= 1">
          <div class='app-setup'>
            <div class="destaque-1">
              Seja Bem Vindo(a) ao Rotina Fácil  
            </div>
            <br/>
            <br/>
            <p class="destaque-2">
              Por favor, selecione os pacotes que deseja testar:
            </p>
            <RF-Pacotes-Contratados style="text-align: left;" 
            :booAlteraPacote="true"
            :cpntIntencao="intencao"
            :cpntFecharAtualizar="appSetupAtualizarPacotes"
            ></RF-Pacotes-Contratados>
          </div>
          <!-- <div class="pergunta-titulo">
            Legal, nos fale um pouco sobre você.
          </div>

          <table>
            <tr>
              <td colspan="3" class="rf-page-setup-titulo" v-html="vetPerguntas[pagina].pergunta"></td>  
            </tr>
            <tr>
              <td class="rf-checkbox">
                <input type="radio" :id='"rf-setup-pergunta-sim-" + pagina' :name='"rf-setup-pergunta" + pagina' :value="true" :checked='vetPerguntas[pagina].value === true' :tabIndex='formulario.tabIndexFieldGeral' @change="setupOnChangeResposta(pagina, true)">
                <label :for='"rf-setup-pergunta-sim-" + pagina' style="cursor: pointer; font-size: var(--font-base-soma-25);">&nbsp;Sim</label>
              </td>  
              <td class="rf-checkbox">
                <input type="radio" :id='"rf-setup-pergunta-nao-" + pagina' :name='"rf-setup-pergunta" + pagina' :value="false" :checked='vetPerguntas[pagina].value === false' :tabIndex='formulario.tabIndexFieldGeral' @change="setupOnChangeResposta(pagina, false)">
                <label :for='"rf-setup-pergunta-nao-" + pagina' style="cursor: pointer; font-size: var(--font-base-soma-25);">&nbsp;Não</label>
              </td>  
            </tr>
          </table> -->
        </div>

        <!-- PAGINA DO TIPO >= 1 -->
        <!-- =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- -->
        <!-- <div class="rf-setup-rodape" v-if="pagina >= 1">
          <RF-Button style="float: left;"
            :data-time='time'

            :cpntStatus='""' 
            :cpntId='formulario.id + "-anterior"' 
            :cpntTexto='"Anterior"' 
            :cpntTipo='"icone-texto"'
            :cpntIcone='{ id: formulario.id + "-bt-icone", tipo: "circle-left", class: "rf-setup-button-icon" }'
            :cpntClass='[ "btn", "btn-default" ]'
            :cpntDisabled='pagina === 1'

            @onClickButton='setupOnClickButton'
          ></RF-Button>

          <RF-Button style="float: right;" v-if="(pagina === 6 && vetPerguntas[vetPerguntas[7].dependente[0]].value === true) || (pagina !== 6 && Object.keys(vetPerguntas).length !== pagina)"
            :data-time='time'

            :cpntStatus='""' 
            :cpntId='formulario.id + "-proximo"' 
            :cpntTexto='"Próximo"' 
            :cpntTipo='"texto-icone"'
            :cpntIcone='{ id: formulario.id + "-bt-icone", tipo: "circle-right", class: "rf-setup-button-icon" }'
            :cpntClass='vetPerguntas[pagina].value === "" ? [ "btn", "btn-default" ] : [ "btn", "btn-default", "btn-primary" ]'
            :cpntDisabled='Object.keys(vetPerguntas).length === pagina'

            @onClickButton='setupOnClickButton'
          ></RF-Button>

          <RF-Button style="float: right;" v-else
            :data-time='time'

            :cpntStatus='""' 
            :cpntId='formulario.id + "-finalizar"' 
            :cpntTexto='"Finalizar"' 
            :cpntTipo='"texto"'
            :cpntClass='vetPerguntas[pagina].value === "" ? [ "btn", "btn-default" ] : [ "btn", "btn-default", "btn-primary" ]'

            @onClickButton='setupOnClickButton'
          ></RF-Button>
        </div> -->
      </div>
    </transition>

    <template v-if="pagina !== 'progresso'">
      <RF-Dialog v-if='Object.keys(formulario).length >= 1 && termoMostrar === true'
        :cpntStatus='""'
        :cpntLargura='"770px"'
        :cpntTitulo="'Contrato Demonstrativo - Software Rotina Fácil'"

        :cpntOnFecharDialog='function () { termoMostrar = !termoMostrar }'>
        <template slot='conteudo'>
          <div style="min-height: 90%; min-height: 450px;">
            <iframe style="width: 100%; min-height: 450px; border: 1px #ccc solid;" src="https://s3-sa-east-1.amazonaws.com/arq.rotinafacil.com/termos/demonstrativo/2012-04-13_rf_termos.pdf"></iframe>
          </div>
        </template>
      </RF-Dialog>

      <div style="display:inline;" v-if="Object.keys(formulario).length >= 1 && conta !== '' && formulario.hasOwnProperty('buttons') && formulario.buttons.hasOwnProperty('env') && formulario.buttons.env.status === 'carregando'">
        <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/970578862/?value=4.00&amp;currency_code=BRL&amp;label=mbdCCOWIq2AQrrfnzgM&amp;guid=ON&amp;script=0"/>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .app-setup-progress {
    position: absolute;
    width: calc(100% - 20px);
    height: 100%;
    text-align: center;
  }
  .app-setup-progress > div {
    max-width: 600px;
    margin: 0px auto;
    margin-top: calc((100vh / 2) - (280px / 2));
  }
    .app-setup-progress > div .app-setup-progress-valor {
      position: relative;
      top: 23px;
      text-align: center;
    }
    .app-setup-progress > div .app-setup-progress-barra {
      margin-bottom: 0px !important;
    }
    .app-setup-progress > div > div > h2 {
      font-size: 25px;
    }
    .app-setup-progress > div > div > h4 {
      font-size: 20px;

    }

  /* CONFIGURAÇÃO GERAIS DA PAGINA */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .rf-page-setup {
    font-size: var(--font-base-soma-18);
  }
  .rf-page-setup > .rf-page-setup-conteudo.page-cadastro {
    width: 340px;
    margin: 0px auto;
    padding: 20px 0px;
  }
    .rf-page-setup > .rf-page-setup-conteudo .rf-page-setup-logo {
      text-align: center;
    }
    .rf-page-setup > .rf-page-setup-conteudo .rf-page-setup-titulo {
      text-align: center;
      padding: 30px 0px;
      font-size: var(--font-base-soma-25);
    }

  /* CONFIGURAÇÃO DA PARTE DE CADASTRO */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
    .rf-page-setup > .rf-page-setup-conteudo > .rf-page-setup-cadastro {
      padding: 20px 0px 30px 0px;
    }

  /* CONFIGURAÇÃO DA PARTE DE PERGUNTAS */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .rf-page-setup-conteudo {
    /* height: 70vh; */
  }
  .rf-setup-perguntas > .pergunta-titulo {
    margin: 10% 0px 5% 0px;
    text-align: center;
  }
  .rf-setup-perguntas > table {
    width: 100%;
  }
    .rf-setup-perguntas > table > tr > td {
      width: 50%;
      padding: 5% 0px 5% 0px;
      text-align: center;
    }

  .rf-setup-perguntas ~ .rf-setup-rodape {
    margin: 10% 0px 10% 0px;
    padding: 15px 0px;
  }

  /* CONFIGURAÇÃO DO RODAPÉ DO BOX */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .rf-setup-rodape {
    padding: 15px 20px;
  }
    .rf-setup-rodape > button {
      width: 120px;
    }

  /* ANIMAÇÕES INICIAIS */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
    @keyframes bounce-in {
      from,
      60%,
      75%,
      90%,
      to {
        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      }

      0% {
        opacity: 0;
        -webkit-transform: translate3d(-3000px, 0, 0);
        transform: translate3d(-3000px, 0, 0);
      }
      60% {
        opacity: 1;
        -webkit-transform: translate3d(25px, 0, 0);
        transform: translate3d(25px, 0, 0);
      }
      75% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0);
      }
      90% {
        -webkit-transform: translate3d(5px, 0, 0);
        transform: translate3d(5px, 0, 0);
      }
      to {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
      }
    }

  
.app-setup {
  width: 905px !important;
  margin: 0px auto !important;
  padding-top: 10px;
  text-align: center;
}
.destaque-1 {
  font-size: 30px;
  font-weight: bold;
  font-weight: 500;
  line-height: 1.1;
  color: #000;
}
.destaque-2 {
  font-size: 16px;
  font-weight: bold;
  font-weight: 500;
  line-height: 1.1;
  color: #000;
}
</style>

<style>
  .rf-page-setup > .rf-page-setup-conteudo #setup-form-env {
    font-size: var(--font-base-soma-18);
  }
  .rf-page-setup > .rf-page-setup-conteudo > .rf-page-setup-cadastro > .rf-form > div.rf-input-group {
    margin-top: 15px;
  }
  .rf-page-setup > .rf-page-setup-conteudo > .rf-page-setup-cadastro > .rf-form > div.rf-input-group:last-child {
    margin-bottom: 0px !important;
  }
  .rf-page-setup > .rf-page-setup-conteudo > .rf-page-setup-cadastro > .rf-form > div.rf-input-group label,
  .rf-page-setup > .rf-page-setup-conteudo > .rf-page-setup-cadastro > .rf-form > div.rf-input-group input {
    font-size: var(--font-base-soma-16);
  }
</style>

<!-- Global site tag (gtag.js) - Google Ads: 970578862 --> 
<script async src="https://www.googletagmanager.com/gtag/js?id=AW-970578862"></script>

<script>
  // CHAMA A FUNÇÃO PARA SETAR AS INFORMAÇOES DE CONVERÇÕES
  window.dataLayer = window.dataLayer || []
  window.gtag = () => { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', 'AW-970578862')

  import { SESSAO_LOGIN_SALVAR, SESSAO_ATUALIZAR_TOKEN } from '@/assets/js/Sessao.js'

  export default {
    components: {
      // 'RF-Button': () => import('@/components/rf-geral/button/RF-Button.vue')
      // 'b-modal': () => import('bootstrap-vue/es/components/modal/modal'),
      // 'b-progress': () => import('bootstrap-vue/es/components/progress/progress')
      // 'App-Setup-Logado': () => import('@/components/setup/Setup-Logado.vue')
      'RF-Pacotes-Contratados': () => import('@/components/config/pacotes/RF-Pacotes-Contratados.vue')
    },
    directives: {
      // 'b-modal': 'bootstrap-vue/es/directives/modal/modal'
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        clu: null,
        conta: null,
        cts: null,
        salvar: null,
        pagina: null,
        formulario: {},
        checkbox: false,
        termoMostrar: false,
        progress: 0,
        progressoSetup: null,
        intencao: 'docfiscal',
        vetPerguntas: {
          1: {
            pergunta: 'Trabalha com Produtos?',
            value: '',
            dependente: [],
            pacote: [ 6, 20 ]
          },
          2: {
            pergunta: 'Vende para Consumidor Final?',
            value: '',
            dependente: [ 1 ],
            pacote: [ 23, 16 ]
          },
          3: {
            pergunta: 'Possui Estoque para controlar?',
            value: '',
            dependente: [ 1 ],
            pacote: [ 5 ]
          },
          4: {
            pergunta: 'Trabalha com Serviços?',
            value: '',
            dependente: [],
            pacote: [ 15, 25 ]
          },
          5: {
            pergunta: 'Controla comissão dos Colaboradores?',
            value: '',
            dependente: [ 1 ],
            pacote: [ 27 ]
          },
          6: {
            pergunta: 'Emite boletos ou controla o Financeiro?',
            value: '',
            dependente: [],
            pacote: [ 4 ]
          },
          7: {
            pergunta: 'Deseja emitir Nota Fiscal com o Rotina Fácil?',
            value: '',
            dependente: [],
            pacote: []
          }
        }
      }
    },
    mounted: function () {
      this.setupIniciar()
    },
    methods: {
      setupIniciar: function (tentativa = 0) {
        if ([ '', null, undefined ].indexOf(this.$store.state.token) !== -1 || [ '', null, undefined ].indexOf(this.$store.state.token.cts) !== -1 || this.$store.state.token.clu_pcc.length === 1) {
          // SETA A PAGINA COM O STATUS DE CARREGANDO
          this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])

          if (this.hasOwnProperty('$store') && this.$store.state.hasOwnProperty('FUN_CREATE_BUTTON_FORM')) {
            this.setupIniciarTela()
          } else if (tentativa <= 15 && this.$store.state.token) {
            var self = this
            setTimeout(function () {
              self.setupIniciar(tentativa + 1)
            }, 1000)
          }
        }
      },
      setupIniciarTela: function () {
        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        this.formulario = {
          status: 'carregando',
          id: 'setup-form',
          field: {},
          buttons: {},
          tabIndexFieldGeral: 10000000,
          tabIndexButtonGeral: 10000002
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A INTENÇÃO DO CADASTRO
        this.intencao = [ '', null, undefined ].indexOf(this.$route.params.intencao) === -1 ? this.$route.params.intencao : 'docfiscal'

        // CHAMA A FUNÇÃO PARA INCIAR
        switch (this.$route.name) {
          case 'pag_setup_intencao':
            this.setupIniciarFormulario()
            break

          case 'pag_setup_2':
            if (this.$store.state.token.clu_pcc.length === 1 && this.$store.state.token.clu_pcc[0] === 1) {
              // SETA A CONTA QUE ESTA LOGADA
              this.conta = this.$store.state.token.conta

              // SETA O CTS UTILIZADO PARA ESTA CONTA
              this.cts = this.$store.state.token.cts

              // SETA A PAGINA COM O STATUS DE CARREGANDO
              this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // SETA A PAGINA INCIAL DE PERGUNTAS
              this.setupAlterarPagina(1)
            } else {
              // SETA A PAGINA COM O STATUS DE CARREGANDO
              this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])

              // MANDA PARA TELA INICIAL
              this.$router.push({ name: 'pag_inicial' })
            }
            break
        }
      },
      setupIniciarFormulario: function () {
        var self = this

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.formulario.field.nome = {
          tamanho: 50,
          tipo: 'input',
          nome: 'Nome:',
          value: '',
          onChange: self.setupOnChangeValue
        }

        self.formulario.field['separador-' + Object.keys(self.formulario.field).length] = { tipo: 'clear', mostrar: true }

        self.formulario.field.email = {
          tamanho: 50,
          tipo: 'input',
          nome: 'E-mail:',
          value: '',
          onChange: self.setupOnChangeValue
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.formulario.contar = 0
        if (self.$route.params.hasOwnProperty('nome')) {
          self.formulario.field.nome.value = self.$route.params.nome
          self.formulario.contar = self.formulario.contar + 1
        }
        if (self.$route.params.hasOwnProperty('email')) {
          self.formulario.field.email.value = self.$route.params.email
          self.formulario.contar = self.formulario.contar + 1
        }
        if (self.$route.params.hasOwnProperty('checkbox')) {
          self.checkbox = self.$route.params.checkbox
          self.formulario.contar = self.formulario.contar + 1
        }

        // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, [ 0 ], null, {
            env: function () {
              var tipoCampo = []

              if (self.formulario.field.nome.value === '') {
                tipoCampo.push('nome')
              }

              if (self.formulario.field.email.value === '') {
                tipoCampo.push('email')
              }

              if (self.checkbox !== true) {
                tipoCampo.push('checkbox')
              }

              if (tipoCampo.length === 0) {
                self.setupIniciarCadastro()
              } else {
                var mensagem = ''

                if (tipoCampo.length === 3) {
                  mensagem = 'É necessario preencher um nome, e-mail e aceitar o termo demonstrativo para continuar.'
                } else if (tipoCampo.length === 2) {
                  if (tipoCampo[0] === 'nome' && tipoCampo[1] === 'email') {
                    mensagem = 'É necessario preencher um nome e o e-mail para continuar.'
                  } else if (tipoCampo[0] === 'email' && tipoCampo[1] === 'checkbox') {
                    mensagem = 'É necessario preencher um e-mail e aceitar o termo demonstrativo para continuar.'
                  } else if (tipoCampo[0] === 'nome' && tipoCampo[1] === 'checkbox') {
                    mensagem = 'É necessario preencher um nome e aceitar o termo demonstrativo para continuar.'
                  }
                } else if (tipoCampo.length === 1) {
                  switch (tipoCampo[0]) {
                    case 'nome':
                      mensagem = 'É necessario preencher um nome para continuar.'
                      break

                    case 'email':
                      mensagem = 'É necessario preencher um e-mail para continuar.'
                      break

                    case 'checkbox':
                      mensagem = 'É necessario aceitar o termo demonstrativo para continuar.'
                      break
                  }
                }

                // APRESENTA A MENSAGEM RECEBIDA DA API
                self.$store.state.msgWarn('WEB [500]: ' + mensagem, 'danger')
              }
            }
          }, function (buttons) {
            // SETA O NOVO NOME DO BOTÃO
            buttons.env.texto = 'Cadastrar-se'

            // CRIA OS BUTTONS DO FORMULARIO
            self.formulario.buttons = buttons

            // SETA O STATUS PARA O FORMULARIO
            self.formulario.status = ''

            // SETA O CAMPO QUE RECEBE O FOCUS
            self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', 'nome', false)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // SETA A PAGINA COM O STATUS DE CARREGANDO
            self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])

            // CHAMA A FUNÇÃO PARA INCIAR
            self.setupAlterarPagina(0)

            if (self.formulario.contar === 3) {
              setTimeout(function () {
                self.formulario.buttons.env.onClick()
              }, 500)
            }
          })
        })
      },
      setupProcuraPagina: function (index) {
        var self = this

        var pagina = ''

        const vetOrdenado = {}

        // ORDENA AS PERGUNTAS DISPOSNIVELS
        var keys = Object.keys(self.vetPerguntas).sort()

        // REORDENA O VETOR RECEBIDO
        if (index === 'anterior') {
          keys.reverse()
        }

        // ADICIONA O VETOR NA ORDEM CORRETA
        keys.forEach(function (key) {
          vetOrdenado['_' + key] = self.vetPerguntas[key]
        })

        if (self.pagina === 4 && vetOrdenado['_1'].value === false) {
          vetOrdenado['_5'].dependente = [ 4 ]
          vetOrdenado['_7'].dependente = [ 4 ]
        } else {
          vetOrdenado['_5'].dependente = [ 1 ]
          vetOrdenado['_7'].dependente = [ 1 ]
        }

        for (var key in vetOrdenado) {
          if (pagina === '') {
            var keyPergunta = Number(key.substring(1, key.length))
            var keyTalvez = ''

            // REALIZA A ORDENAÇÃO CONFORME SOLICITADO
            switch (index) {
              case 'proximo':
                if (keyPergunta > self.pagina) {
                  keyTalvez = keyPergunta
                }
                break

              case 'anterior':
                if (keyPergunta < self.pagina) {
                  keyTalvez = keyPergunta
                }
                break
            }

            if (keyTalvez !== '') {
              //  PEGA TODAS A PERGUNTA DEPENDENTE ENCONTRADAS
              var dependentes = self.vetPerguntas[keyTalvez].dependente

              // VERIFICA SE AS PERGUNTAS DEPENDENTES FORAM RESPONDIDAS
              if (dependentes.filter(item => self.vetPerguntas[item].value === true).length === dependentes.length) {
                pagina = keyPergunta
              }
            }
          }
        }

        if (pagina !== '') {
          self.setupAlterarPagina(pagina)
        } else {
          // APRESENTA A MENSAGEM RECEBIDA DA API
          self.$store.state.msgWarn('WEB [500]: Erro ao capturar a pergunta solicitada.', 'danger')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }
      },
      setupAlterarPagina: function (pagina) {
        var self = this

        if (self.pagina === null || pagina < self.pagina || (self.vetPerguntas.hasOwnProperty(self.pagina) && self.vetPerguntas[self.pagina].value !== '')) {
          // LIMPA A PERGUNTA SELECIONADA PARA FAZER ANIMAÇÃO
          self.pagina = null

          // VERIFICA QUANTO TEMPO DEVE AGUARDAR PARA TROCAR DE PERGUNTA
          var time = pagina === 1 && self.pagina === 0 ? 300 : 0

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          setTimeout(function () {
            // SETA A PERGUNTA RECEBIDA
            self.pagina = pagina

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA CALCULAR A PORCENTAGEM
            self.setupPorcetagemCompleto()
          }, time)
        } else {
          // APRESENTA A MENSAGEM RECEBIDA DA API
          self.$store.state.msgWarn('WEB [400]: Selecione ao menos uma opção para continuar.', 'danger')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }
      },
      setupPorcetagemCompleto: function () {
        // PEGA O TOTAL DE PERGUNTAS ENCONTRADAS
        var countAll = Object.keys(this.vetPerguntas).length

        // CALCULA A PORCENTAGEM RESPONDIDA
        this.progress = (100 / countAll) * Object.keys(this.vetPerguntas).filter(item => item <= this.pagina && this.vetPerguntas[item].value !== '').length

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      setupOnChangeResposta: function (pergunta, value) {
        // SETA O VALOR RECEBIDO
        this.vetPerguntas[pergunta].value = value

        // SETA O VALOR PARA AS OUTRAS PERGUNTAS
        for (var key in this.vetPerguntas) {
          if (this.vetPerguntas[key].dependente.indexOf(pergunta) !== -1) {
            this.vetPerguntas[key].value = value === false ? value : ''
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      setupOnChangeValue: function (value, campo) {
        var index = campo.substring((this.formulario.id.length + 1), campo.length)

        // SETA O VALOR RECEBIDO
        this.formulario.field[index].value = value

        // LIMPA AS MENSAGENS DOS CAMPOS
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        switch (index) {
          case 'nome':
          case 'email':
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      setupVerificarProgressoCriacaoBase: function () {
        // LIMPA A FUNÇÃO PARA BUSCAR
        clearTimeout(this.progressoSetup)

        // VERIFICA SE TEM CLU
        if ([ '', null, undefined ].indexOf(this.clu) === -1 && this.progress < 100) {
          this.$store.state.comunicaAPI('/subase/cadastro/chk-porcentagem/get/' + this.clu, 'GET', null, (retorno) => {            
            // SETA O VALOR RECEBIDO NO CAMPO DE PROGRESSO
            this.progress = Number(retorno.data)

            // CHAMA A FUNÇÃO PARA REINICIAR A BUSCA
            this.progressoSetup = setTimeout(() => { this.setupVerificarProgressoCriacaoBase() }, 3000)
          }, this.setupSetStatusGeral)
        }
      },
      setupIniciarCadastro: function () {
        var self = this

        // SETA O STATUS NO BOTÃO
        self.formulario.buttons.env.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // MONSTA O QUERY GET
        var queryGet = window.btoa(self.formulario.field.email.value)

        // REALIZA A COMUNICAÇÃO COM A API
        self.$store.state.comunicaAPI('/subase/cadastro/chk-mail/get/', 'GET', queryGet, function (apiSuccess) {
          if (apiSuccess.data.hasOwnProperty('tok-pre-cadastro')) {
            var formData = {
              intencao: self.$route.params.intencao,
              nome: self.formulario.field.nome.value,
              'tok-pre-cadastro': apiSuccess.data['tok-pre-cadastro'],
              'act-demonstrativo': 'true',
              clu: apiSuccess.data.clu
            }

            // SETA O NOME DA CLU QUE ESTÁ SENDO CRIADA
            self.clu = apiSuccess.data.clu

            // REALIZA A COMUNICAÇÃO COM A API
            self.$store.state.comunicaAPI('/subase/cadastro/cli-novo', 'POST', formData, function (apiSuccess) {
              if (apiSuccess.data.hasOwnProperty('conta')) {
                // CHAMA A FUNÇÃO PARA SETAR AS INFORMAÇOES DE CONVERÇÕES
                window.gtag('event', 'conversion', { 'send_to': 'AW-970578862/mbdCCOWIq2AQrrfnzgM', 'value': 4.0, 'currency': 'BRL' })

                // REALIZA O LOGIN PARA CRIAR OS DADOS DO TOKEN
                self.setupRealizarLogin(apiSuccess.data.conta, function (cts) {
                  // self.$router.push({ name: 'pag_setup_2', params: { cts: cts } })
                  // // SETA O DADOS DA CONTA
                  // self.conta = apiSuccess.data.conta

                  // // SETA O CTS DA CONTA GERADO
                  // self.cts = cts

                  // VERIFICA SE DEVE CHAMAR A FUNÇÃO PARA SALVAR
                  // if (self.salvar === true) {
                  //   self.setupOnClickButton(self.formulario.id + '-finalizar')
                  // }
                  // if (self.salvar !== null) {
                  //   self.salvar(() => { self.$router.push({ name: 'pag_inicial', params: { cts: cts } }) })
                  // }
                  self.$router.push({ name: 'pag_inicial', params: { cts: cts } })
                })
              }
            }, function (apiError) {
              self.setupSetStatusGeral(apiError)
            }, function (apiValid, apiStatus) {
              // SETA O STATUS NO BOTÃO
              self.formulario.buttons.env.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // SETA A MENSAGEM RECEBIDA DA API
              self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, function (field, focus, apiValid) {
                // SETA OS CAMPOS COM OS ERROS
                self.formulario1.field = field
              })
            })

            // // LIMPA A PERGUNTA SELECIONADA PARA FAZER ANIMAÇÃO
            // self.pagina = null

            // // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            // self.time = new Date().getTime()

            // // SETA A PAGINA INCIAL DE PERGUNTAS
            // self.setupAlterarPagina(1)
          } else if (apiSuccess.data.hasOwnProperty('conta')) {
            self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: false }])

            self.setupRealizarLogin(apiSuccess.data.conta, function (cts) {
              // VERIFICA SE DEVE APRESENTAR AS INFORMAÇOES
              self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])

              // REDIRECIONA PARA PAGINA INICIAL
              self.$router.push({ name: 'pag_inicial', params: { cts: cts } })

              if (self.$store.state.token.clu_pcc.length === 1 && self.$store.state.token.clu_pcc[0] === 1) {
                // LIMPA A PERGUNTA SELECIONADA PARA FAZER ANIMAÇÃO
                self.pagina = null

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                // VERIFICA SE DEVE APRESENTAR AS INFORMAÇOES
                self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])

                // INICIA O PROCESSO NOVAMENTE
                setTimeout(function () {
                  // VERIFICA SE DEVE APRESENTAR AS INFORMAÇOES
                  self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])

                  // CHAMA A FUNÇÃO PARA REINICIAR O COMPONENT SETUP
                  self.setupIniciar()
                }, 1000)
              }
            })
          } else {
            // eslint-disable-next-line
            console.warn(apiSuccess)
          }
        }, function () {
          // SETA O STATUS NO BOTÃO
          self.formulario.buttons.env.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      setupRealizarLogin: function (conta, callback = null) {
        var self = this

        // SETA OS DADOS DE LOGIN
        var formData = {
          conta: conta,
          senha: 'subase'
        }

        // SETA A INFORMAÇÃO SE ESTA RODANDO NO ELECTRON OU NÃO
        formData.ect = window.ELECTRON

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        self.$store.state.comunicaAPI('/acesso', 'POST', formData, function (apiSuccess) {
          // SETA OS DADOS QUE DEVEM SER SALVOS TAMBEM
          apiSuccess.data.conta = conta
          apiSuccess.data.salvar = true

          // IMPORTA A FUNÇÃO PARA REMOVER A CONTA DO CS
          const SESSAO_LOGIN_SALVAR = require('@/assets/js/Sessao.js').SESSAO_LOGIN_SALVAR
  
          // CHAMA FUNÇÃO PARA SALVAR LOCALSTORAGE
          SESSAO_LOGIN_SALVAR(apiSuccess.data, (cts) => {
            if (callback !== null && typeof callback === 'function') {
              callback(cts)
            }
          })
        }, function (apiError) {
          self.setupSetStatusGeral(apiError)
        })
      },
      setupOnClickButton: function (button) {
        var index = button.substring((this.formulario.id.length + 1), button.length)

        switch (index) {
          case 'proximo':
          case 'anterior':
            // CHAMA A FUNÇÃO PARA INCIAR
            this.setupProcuraPagina(index)
            break

          case 'finalizar':
            if ((this.vetPerguntas.hasOwnProperty(this.pagina) && this.vetPerguntas[this.pagina].value !== '') || this.pagina === 'progresso') {
              // CHAMA A FUNÇÃO PARA CALCULAR A PORCENTAGEM
              this.setupPorcetagemCompleto()

              if (this.conta !== null) {
                // SETA OS PACOTES PADRÕES PARA COMEÇAR
                var pacotes = [ 1, 21, 17 ]

                // ADICIONA O PACOTE DE VEICULO SE A INTENÇÃO DE CADASTRO VIER DE UMA PAGINA DE VEICULO
                if (this.$store.state.licenca.intencao === 'oficina') {
                  pacotes.push(8)
                } 

                // ADICIONA O PACOTE DE PET SE A INTENÇÃO DE CADASTRO VIER DE UMA PAGINA DE PETSHOP
                if (this.$store.state.licenca.intencao === 'petshop') {
                  pacotes.push(28)
                }

                // BUSCA OS PACOTES SELECIONADOS
                for (var key in this.vetPerguntas) {
                  if (this.vetPerguntas[key].value === true) {
                    pacotes = pacotes.concat(this.vetPerguntas[key].pacote)
                  }
                }

                // VERIFICA QUAIS SÃO OS PACOTES DE NOTA QUE DEVE ADICIONAR
                if (this.vetPerguntas[7].value === false) {
                  pacotes = pacotes.filter(item => [ 20, 23, 25 ].indexOf(item) === -1)
                }

                // REMOVER VALORES DUPLICADOS
                pacotes = pacotes.filter((v, i, a) => a.indexOf(v) === i)

                // CHAMA A FUNÇÃO PARA ATUALIZAR OS PACOTES NA API
                this.setupOnAlteraPacotes(pacotes)
              } else if (this.salvar === false && this.conta === null) {
                // SETA O STATUS PARA SALVAR
                this.salvar = true

                // LIMPA A PERGUNTA SELECIONADA PARA FAZER ANIMAÇÃO
                this.pagina = 'progresso'

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()

                // LIMPA A BARRA DE PROGRESS
                this.progress = 0

                // INICIA O PROCESSAMENTO DA PORCENTAGEM DE CRIAÇÃO DA BASE
                this.setupVerificarProgressoCriacaoBase()

                // SETA A PAGINA COM O STATUS DE CARREGANDO
                // this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }, { chave: 'setup', value: true }])
              }
            } else {
              // APRESENTA A MENSAGEM RECEBIDA DA API
              this.$store.state.msgWarn('WEB [400]: Selecione ao menos uma opção para continuar.', 'danger')

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
            break
        }
      },
      setupOnAlteraPacotes: function (pacote) {
        var self = this

        // CONVERTE O VALOR DOS PACOTES EM UM JSON
        var formData = {
          j_pacotes: JSON.stringify(pacote)
        }

        // SETA A PAGINA COM O STATUS DE CARREGANDO
        self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: false }, { chave: 'setup', value: true }])

        // REDIRECIONA PARA PAGINA DE INICIO
        self.$router.push({ name: 'pag_inicial', params: { cts: self.cts } })

        // COMPLETA A BARRA DE PROGRESS
        this.progress = 100

        // LIMPA A FUNÇÃO PARA BUSCAR
        clearTimeout(this.progressoSetup)

        self.$store.state.comunicaAPI('/config/pacote', 'PUT', formData, function () {
          // SETA A PAGINA COM O STATUS DE CARREGANDO
          self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }, { chave: 'setup', value: true }])

          SESSAO_ATUALIZAR_TOKEN('clu_pcc', function () {
            // // SETA A PAGINA COM O STATUS DE CARREGANDO
            // self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: false }])

            setTimeout(function () {
              // REMOVE A MASCARA DE CARREGANDO
              self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }, { chave: 'setup', value: false }])

              // REDIRECIONA PARA PAGINA DE INICIO
              self.$router.push({ name: 'iniciante', params: { cts: self.cts } })
              // // REDIRECIONA PARA PAGINA DE INICIO
              // self.$router.push({ name: 'venda_nova', params: { cts: self.cts } })

              // setTimeout(function () {
              //   // APRESENTA A MENSAGEM DE SUCESSO
              //   if (self.$store.state.licenca.intencao === 'oficina') {
              //     self.$store.state.msgWarn('Seja bem vindo ao Sistema Rotina Fácil! Vamos testar?<br/><br/>Crie sua nova venda!<br/><br/>Basta digitar a placa do veículo logo abaixo ;)<br/><br/>Qualquer dúvida por favor nos chame no chat localizado no canto inferior esquerdo da sua tela.', 'success', 20)
              //   } else {
              //     self.$store.state.msgWarn('Seja bem vindo ao Sistema Rotina Fácil! Vamos testar?<br/><br/>Crie sua nova venda!<br/><br/>Basta digitar o nome, cpf ou cnpj do seu Cliente logo abaixo ;)<br/><br/>Qualquer dúvida por favor nos chame no chat localizado no canto inferior esquerdo da sua tela.', 'success', 20)
              //   }
              // }, 2000)
            }, 300)
          })
        }, function (apiError) {
          self.setupSetStatusGeral(apiError)
        }, function (apiValid, apiStatus) {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA A MENSAGEM RECEBIDA DA API
          self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, {}, true, function (field, focus, apiValid) {})
        })
      },
      setupSetStatusGeral: function (status = '') {
        // SETA A PAGINA COM O STATUS DE CARREGANDO
        this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])

        // SETA O STATUS RECEBIDO
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appSetupAtualizarPacotes: function (callbackP) {
        // SETA A FUNÇÃO SALVAR
        this.salvar = (callbackS) => { callbackP(callbackS) }

        // VERIFICA SE O PROCESSO DE LOGIN JÁ TERMINOU
        if ([ '', null, undefined ].indexOf(this.$store.state.token) === -1 && Object.keys(this.$store.state.token).length >= 2) {
          this.salvar(() => { this.$router.push({ name: 'pag_inicial', params: { cts: this.$store.state.token.cts } }) })
        } else {
          // LIMPA A PERGUNTA SELECIONADA PARA FAZER ANIMAÇÃO
          this.pagina = 'progresso'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // LIMPA A BARRA DE PROGRESS
          this.progress = 0

          // INICIA O PROCESSAMENTO DA PORCENTAGEM DE CRIAÇÃO DA BASE
          this.setupVerificarProgressoCriacaoBase()
        }
      }
    }
  }
</script>
